// @flow

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const styles = {
  wrapper: {
    padding: '30px',
  },
};

type Props = {
  classes: Object,
  errorMessage: ?string,
}

class NotFoundPage extends React.Component<Props> {
  componentWillMount() {
    // add no indexing meta tag so Google will not index page
    const head = document.getElementsByTagName('head')[0];
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex';
    head.appendChild(meta);
  }

  componentWillUnmount() {
    const metaTags = document.getElementsByTagName('meta');
    for (let i = 0; i < metaTags.length; i += 1) {
      if (metaTags[i].name === 'robots') metaTags[i].remove();
    }
  }

  render() {
    const { classes, errorMessage } = this.props;
    return (
      <div className={classes.wrapper}>
        <Typography variant="h6">{errorMessage || 'Not Found'}</Typography>
      </div>
    );
  }
}

export default withStyles(styles)(NotFoundPage);
